import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import SandboxJiraPageQuery from '@atlassian/jira-relay/src/__generated__/SandboxJiraPageQuery.graphql';

export const sandboxJiraPageEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-sandbox-jira-page", jiraSpaEntry: "jira-spa-sandboxdemo" */ './ui/SandboxJiraPage.tsx'
			),
	),
	getPreloadProps: ({ tenantContext, context }: EntryPointRouteParams) => {
		return {
			queries: {
				pageQueryRef: {
					parameters: SandboxJiraPageQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						enableDefer: Boolean('defer' in context.query ? context.query.defer === 'true' : true),
					},
					options: {
						fetchPolicy: 'network-only' as const,
					},
				},
			},
		};
	},
});
